import henry1 from "../Assets/profile/henry-1.jpg";
import henry2 from "../Assets/profile/henry-2.JPG";
import henry3 from "../Assets/profile/henry-3.JPG";
import henry4 from "../Assets/profile/henry-4.jpg";
import henry5 from "../Assets/profile/henry-5.jpg";
import henry6 from "../Assets/profile/henry-6.jpg";
import henry7 from "../Assets/profile/henry-7.jpg";
import henry8 from "../Assets/profile/henry-8.jpg";
import henry9 from "../Assets/profile/henry-9.JPG";
import henry10 from "../Assets/profile/henry-10.jpg";
import henry11 from "../Assets/profile/henry-11.JPG";
import henry12 from "../Assets/profile/henry-12.jpg";
import henryCat from "../Assets/profile/henry-cat.JPG";

// Location labels are derived from photo GPS metadata where available.
export const profilePhotos = [
  {
    src: henry1,
    alt: "Henry at Lake Tahoe",
    location: "Lake Tahoe, California",
  },
  {
    src: henry2,
    alt: "Henry in Death Valley",
    location: "Death Valley, California",
  },
  {
    src: henry3,
    alt: "Henry in Las Vegas",
    location: "Las Vegas, Nevada",
  },
  {
    src: henry4,
    alt: "Henry in China",
    location: "China",
  },
  {
    src: henry5,
    alt: "Henry in China",
    location: "China",
  },
  {
    src: henry6,
    alt: "Henry in China",
    location: "China",
  },
  {
    src: henry7,
    alt: "Henry in China",
    location: "China",
  },
  {
    src: henry8,
    alt: "Henry in China",
    location: "China",
  },
  {
    src: henry9,
    alt: "Henry in Montréal",
    location: "Montréal, Canada",
  },
  {
    src: henry10,
    alt: "Henry in Maui",
    location: "Maui, Hawaii",
  },
  {
    src: henry11,
    alt: "Henry in Moorea",
    location: "Moorea, French Polynesia",
  },
  {
    src: henry12,
    alt: "Henry in Ensenada",
    location: "Ensenada, Baja California",
  },
  {
    src: henryCat,
    alt: "Henry with his cat in Las Vegas",
    location: "Las Vegas, Nevada",
  },
];
